import React from 'react';
import { useTranslate } from '../../hooks/useTranslate';

interface AuthLoadingProps {
    message?: string;
}

/**
 * Loading component shown during Azure AD authentication
 */
const AuthLoading: React.FC<AuthLoadingProps> = ({
    message = "Authenticating with Azure AD..."
}) => {
    const { t } = useTranslate();
    return (
        <div className="zoom-reset text-white flex items-center justify-center" style={{
            backgroundImage: 'url("/Login Page.png")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'fixed',
            top: 0,
            left: 0,
        }}>
            <div className="text-center space-y-6">
                {/* App logo/branding */}
                <div className="mb-8 flex flex-col items-center">
                    <img 
                        src="/new_logo.png" 
                        alt="Data Doctor Logo" 
                        className="h-40 w-auto object-contain opacity-90"
                        style={{
                            filter: 'drop-shadow(0 4px 12px rgba(155, 5, 39, 0.08))',
                            maskImage: 'linear-gradient(to bottom, transparent 0%, black 8%, black 92%, transparent 100%), radial-gradient(ellipse at center, black 85%, transparent 100%)',
                            WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 8%, black 92%, transparent 100%), radial-gradient(ellipse at center, black 85%, transparent 100%)',
                            maskComposite: 'intersect',
                            WebkitMaskComposite: 'source-in'
                        }}
                    />
                </div>

                {/* Loading spinner */}
                <div className="flex justify-center">
                    <div className="loader loader-xl"></div>
                </div>

                {/* Loading message */}
                <p className="text-white text-lg">{t(message)}</p>

                {/* Microsoft branding */}
                <div className="text-sm text-white mt-8">
                    <p>{t('Redirecting to Microsoft Azure Active Directory')}</p>
                </div>
            </div>
        </div>
    );
};

export default AuthLoading;